
					export const lastCommitHash = '1f256cf1c75d3f9b25fdf1eef999346a68b42876';
					export const lastCommitHashForBitbuet = '1f256cf1c75';

					export const packageVersion = '10.6.0';

					export const branchName = '';
					